export default __webpack_public_path__ + "static/media/lengua.de9b29ee.jpg";